import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, Grid, Modal, Stack, TextField, Typography } from "@mui/material";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import user3Service from "../../../services/user3Service";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  boxShadow: 24,
  p: 3,
};

const User3 = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [editValues, setEditValues] = useState({});

  const fetchUser = async () => {
    try {
      const res = await user3Service.getOneUser(instanceToken.token, id);
      setUser(res.data);
      setEditValues(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleUpdate = async () => {
    try {
      await user3Service.updateUser(instanceToken.token, id, editValues);
      homeAlert("User updated successfully.", false);
      setOpenEdit(false);
      fetchUser();
    } catch (error) {
      console.error(error);
      homeAlert("Error updating user!", true);
    }
  };

  const handleRemove = async () => {
    try {
      await user3Service.deleteUser(instanceToken.token, id);
      homeAlert("User has been removed.", false);
      navigate("/users3");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  return (
    <>
      <DetailPageLayout
        title="User Details"
        subtitle="View and manage level 3 user"
        breadcrumbs={[
          { label: "Users (Level 3)", path: "/users3" },
          { label: `User (ID - ${id})` },
        ]}
        listPath="/users3"
        loading={!user}
        onEdit={() => setOpenEdit(true)}
        onRemove={handleRemove}
        infoItems={
          user
            ? [
                { label: "User ID", value: user.userid, icon: "id" },
                { label: "Username", value: user.username, icon: "person" },
                { label: "Name", value: user.name, icon: "person" },
                { label: "Email", value: user.email, icon: "email" },
                { label: "Phone Number", value: user.phone_number, icon: "phone" },
                { label: "Role", value: user.role, icon: "info" },
                { label: "OTP Exp Time", value: user.otp_exp_time, icon: "calendar" },
                {
                  label: "One Time Password",
                  value: user.one_time_password,
                  icon: "info",
                },
                ...dateInfoItems(user),
              ]
            : []
        }
        infoTitle="User Information"
      />

      <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" component="h2" mb={2}>
            Edit User Profile
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Name"
                value={editValues.name || ""}
                onChange={(e) =>
                  setEditValues({ ...editValues, name: e.target.value })
                }
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                value={editValues.email || ""}
                onChange={(e) =>
                  setEditValues({ ...editValues, email: e.target.value })
                }
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Phone Number"
                value={editValues.phone_number || ""}
                onChange={(e) =>
                  setEditValues({ ...editValues, phone_number: e.target.value })
                }
                size="small"
              />
            </Grid>
          </Grid>
          <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
            <Button onClick={() => setOpenEdit(false)} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleUpdate} variant="contained" color="primary">
              Update
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default User3;
